import { buffers, END, eventChannel } from "redux-saga";

import log from "loglevel";
import { getCurrentUserToken } from "services";

export function createUploadFileChannel(endpoint, file) {
    log.debug("-------execute file channel url", endpoint);
    return eventChannel((emitter) => {
        const xhr = new XMLHttpRequest();
        const onProgress = (e) => {
            if (e.lengthComputable) {
                const progress = e.loaded / e.total;
                emitter({ progress });
            }
        };
        const onFailure = (e) => {
            log.error(e);
            emitter({ err: new Error("Upload failed") });
            emitter(END);
        };
        xhr.upload.addEventListener("progress", onProgress);
        xhr.upload.addEventListener("error", onFailure);
        xhr.upload.addEventListener("abort", onFailure);
        xhr.onreadystatechange = () => {
            const { readyState, status } = xhr;
            if (readyState === 4) {
                if (status === 200) {
                    emitter({ success: true });
                    emitter(END);
                } else {
                    onFailure(null);
                }
            }
        };
        const formData = new FormData();
        formData.append("file", file);

        xhr.open("POST", endpoint, true);
        const token = getCurrentUserToken();
        if (token) {
            xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        } else {
            xhr.withCredentials = true;
        }
        xhr.send(formData);
        return () => {
            xhr.upload.removeEventListener("progress", onProgress);
            xhr.upload.removeEventListener("error", onFailure);
            xhr.upload.removeEventListener("abort", onFailure);
            xhr.onreadystatechange = null;
            xhr.abort();
        };
    }, buffers.sliding(2));
}
